import InquiryCallbackStatusBadge from "./InquiryCallbackStatusBadge";

export function InquiryCallbackSummary ({ data }) {
  return (
        <div className="card mb-3">
            <div className="card-header">
                <h5 className="card-title">
                    <i className="fa-solid fa-circle-info me-1" />
                    Details
                </h5>
            </div>

            <div className="card-body">

                <div className="row g-3">

                    <div className="col-md-3">
                        <div className="text-muted small">
                            Device Name
                        </div>

                        <div className="fw-semibold">
                            {data.device_name}
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="text-muted small">
                            Inquiry Type
                        </div>

                        <div className="fw-semibold">
                            {data.inquiryType}
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="text-muted small">
                            Endpoint
                        </div>

                        <code>{data.endpoint}</code>
                    </div>

                    <div className="col-md-3">
                        <div className="text-muted small">
                            Status
                        </div>

                        <InquiryCallbackStatusBadge
                            status={data.status_code}
                        />
                    </div>

                </div>

            </div>
        </div>
  )
}
